export default "__VITE_ASSET__Duc_CzG2__"